// extracted by mini-css-extract-plugin
var _1 = "ZoomStyle-module__btn___W6YF8";
var _2 = "ZoomStyle-module__btn-active___Fh_pr";
var _3 = "ZoomStyle-module__btn-active___Fh_pr";
var _4 = "ZoomStyle-module__zoom___MpeKC";
export { _1 as "btn", _2 as "btn-active", _3 as "btnActive", _4 as "zoom" }
